export default __webpack_public_path__ + "static/6651-27e76fd5a93fe745875ce784a3a507ba.jpg";